import Grid from '@mui/material/Unstable_Grid2/Grid2'
import caixaAgua0 from '../../../Assets/icones/caixa-agua-0.png'
import { useState } from 'react'
import { keyframes } from '@emotion/react'

const ImageCaixaDagua = ({ nivel, sentido }) => {
    const [encherCaixa, setEncherCaixa] = useState(false)

    return (
        <Grid sx={{
            height: '100%',
            width: '50%',
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-end'
        }}>
            <img
                id="caixaAgua"
                src={caixaAgua0}
                onLoad={() => { setEncherCaixa(true) }}
                style={{
                    height: '100%',
                    width: 'fit-content',
                    position: 'absolute'
                }}
            />
            {encherCaixa &&
                <EncherCaixa nivel={nivel} sentido={sentido} />
            }
        </Grid>
    )
}

export default ImageCaixaDagua

const EncherCaixa = ({ nivel, sentido }) => {
    const caixa = document.getElementById('caixaAgua')

    if (!caixa || nivel < 1) {
        return (
            <div
                id="aguaDaCaixa"
            />
        )
    } else if (nivel > 100) {
        nivel = 100
    }

    // Quando foi feito o cálculo para a altura da água, foi considerado esses valores
    // marginBottom agua 45px igual a 14,9% da altura da caixa
    // altura da caixa 302px igual a 100% da altura da caixa
    // altura da agua 220px igual a 72,8% da altura da caixa

    const alturaAgua = (caixa.offsetHeight * 0.728) * (nivel / 100)
    const marginBottomAgua = caixa.offsetHeight * 0.149
    const larguraAgua = caixa.offsetWidth * 0.8

    const blinkAnimation = keyframes`
    0% {
        height: 0px;
    }
    100% {
        height: ${alturaAgua}px;
    }
`

    return (
        <Grid
            id="aguaDaCaixa"
            sx={{
                backgroundColor: '#38DAF0',
                borderRadius: '10px',
                border: nivel > 0 && '#2668FF 2px solid',
                height: `${alturaAgua}px`,
                width: `${larguraAgua}px`,
                marginBottom: `${marginBottomAgua}px`,
                animation: `${blinkAnimation} 1s 1`
            }}
        />
    )
}
